
//验证密码
export function passwordValidate(value ) {

  var pattern =  /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d~!@#$%^&*]{6,20}$/
  if(pattern.test(value)){
    return true;
  }
  return false;
}

